import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { ShoppingListModel } from '@libs/shop/models';
import { ShoppingListsState } from '@libs/shared/services';
import { LuxonDatePipe } from '@libs/shared/ui';
import { ShoppingListActionsComponent } from '../shopping-list-actions';

@Component({
  selector: 'ui-shopping-lists-mobile',
  templateUrl: './shopping-lists-mobile.component.html',
  styleUrls: ['./shopping-lists-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ShoppingListActionsComponent,
    LuxonDatePipe,
  ],
})
export class ShoppingListsMobileComponent {
  public shoppingListsService: ShoppingListsState = inject(ShoppingListsState);
  public shoppingLists: InputSignal<ShoppingListModel[]> = input.required();

  public async showDetailsClicked(shoppingListId: string): Promise<void> {
    await this.shoppingListsService.navigateToDetail(shoppingListId);
  }
}
